import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  OPTION_IDS_VISIBLE_FEATURE_KEY,
  optionIdsVisibleInitialAdapter,
  OptionIdsVisibleInitialState,
} from './option-ids-visible.reducer';
import { DateFilter } from './search-filter-options.models';

// Lookup the 'SearchFilterOptions' feature state managed by NgRx
export const getOptionIsVisibleState =
  createFeatureSelector<OptionIdsVisibleInitialState>(OPTION_IDS_VISIBLE_FEATURE_KEY);

const { selectAll } = optionIdsVisibleInitialAdapter.getSelectors();

export const getOptionIsVisibleLoaded = createSelector(
  getOptionIsVisibleState,
  (state: OptionIdsVisibleInitialState) => state.loaded
);

export const getOptionIdsVisibleError = createSelector(
  getOptionIsVisibleState,
  (state: OptionIdsVisibleInitialState) => state.error
);

export const getAllOptionIdsVisible = createSelector(getOptionIsVisibleState, (state: OptionIdsVisibleInitialState) =>
  selectAll(state)
);

export const getSelectedFacet = createSelector(
  getOptionIsVisibleState,
  (state: OptionIdsVisibleInitialState) => state.selectedFacet
);

export const getSelectedEventDatetimeFilter = createSelector(
  getOptionIsVisibleState,
  (state: OptionIdsVisibleInitialState) => state.dateFilter
);

export const getSelectedEventStartDate = createSelector(
  getOptionIsVisibleState,
  (state: OptionIdsVisibleInitialState) => selectStartDate(state.dateFilter)
);

export const getSelectedEventEndDate = createSelector(getOptionIsVisibleState, (state: OptionIdsVisibleInitialState) =>
  selectEndDate(state.dateFilter)
);

export const getSelectedOptionIdsVisible = createSelector(
  getOptionIsVisibleState,
  (state: OptionIdsVisibleInitialState) => state.selectedOptionIdsVisible
);

function selectStartDate(dateFilter: DateFilter) {
  const { lower } = dateFilter;
  if (!lower) return null;
  return createDate(lower);
}

function selectEndDate(dateFilter: DateFilter) {
  const { upper } = dateFilter;
  if (!upper) return null;
  return createDate(upper);
}

function createDate(timestamp: number) {
  return new Date(timestamp * 1000);
}
